import React from "react";
import Close from "@mui/icons-material/Close";
import { formatCurrency } from "@/main/services/utilsNumber";
import * as S from "./styles";

// Context
import { useCreateOrderContext } from "../../context";

// Utils / Enum
import { OrderStepsEnum } from "@/main/services/enum/OrderStepsEnum";
import { getTranslateByKey, isNullUndefined } from "@/main/services/utils";
import { isShowControlByElementId } from "@/main/services/utils";
import { Controls } from "@/main/services/constants/constantsControl";

// Models
import { QuoteProcurementPartInfoResponse } from "@/main/models/response";

// Components
import QuoteProcurementPartInfo from "@/main/components/shared/quoteProcurementPartInfo/quoteProcurementPartInfo";
import { SpinnerLoading } from "@/main/components/shared/styles";
import CountControl from "@/main/components/shared/countControl/countControl";
import PriceDiffPercent from "@/main/components/shared/priceDiffPercent/priceDiffPercent";
import TypographyPriceCap from "@/main/components/common/typography/typographyPriceCap";

interface IInfoProductProps {
	id: string;
	guidQuoteSupplierItem: string;
	guidSupplier: string;
	guidSupplierInventoryWarehouse: string;
	image?: string;
	price: number;
	stock: number;
	quantity: number;
	isLoading?: boolean;
	isRemoving?: boolean;
	idPartType: number;
	onClickDelete?: (guidQuoteSupplierItem: string, idPart: string) => void;
	onClickIncrement?: (
		guidSupplier: string,
		guidSupplierInventoryWarehouse: string,
		idPartType: number,
		count: number,
	) => void;
	onClickDecrement?: (
		guidSupplier: string,
		guidSupplierInventoryWarehouse: string,
		idPartType: number,
		count: number,
	) => void;
	priceCap: number;
	priceCapFormatted: string;
	priceDiffPercent: number;
	quoteProcurementPartInfo?: QuoteProcurementPartInfoResponse;
	isPaintProject: boolean;
}

function InfoProduct({
	id,
	guidQuoteSupplierItem,
	guidSupplier,
	image,
	price,
	stock,
	quantity,
	idPartType,
	isLoading = false,
	isRemoving = false,
	priceCapFormatted,
	priceDiffPercent,
	isPaintProject,
	onClickDelete = () => {},
	onClickIncrement = () => {},
	onClickDecrement = () => {},
	quoteProcurementPartInfo,
}: IInfoProductProps) {
	const { handleSaveStepData, integration, isQuoteOpen, isQuoteManual } = useCreateOrderContext();

	const showPrices = isShowControlByElementId(Controls.IdShowPrices);

	function handleClickDelete(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
		event.stopPropagation();
		handleSaveStepData(OrderStepsEnum.Summary, false, []);
		onClickDelete(guidQuoteSupplierItem, id);
	}

	const textPrice = `${getTranslateByKey("information.price")}: ${formatCurrency(price)}`;
	return (
		<S.Container>
			{!(integration && isQuoteOpen) && (
				<S.IconButtonClose onClick={handleClickDelete} disabled={isLoading}>
					{isRemoving ? (
						<SpinnerLoading size="small" />
					) : (
						<Close
							fontSize="small"
							id={`id-createOrder-button-deleteProduct-${quoteProcurementPartInfo?.partName || ""}`}
						/>
					)}
				</S.IconButtonClose>
			)}
			<img src={image} alt="" />
			<S.AreaInfo>
				<QuoteProcurementPartInfo
					data={quoteProcurementPartInfo}
					renderType="column"
					showLineSupplierInfo={{ info: "all" }}
				/>
				<S.CustomRowFlex showPrices={showPrices}>
					<S.AreaPrice>
						<S.TextProduct>
							{showPrices && textPrice}
							{!isNullUndefined(priceDiffPercent) && !isPaintProject && (
								<PriceDiffPercent diffPercent={priceDiffPercent} />
							)}
						</S.TextProduct>
						{showPrices && !isPaintProject && <TypographyPriceCap priceCap={priceCapFormatted} />}
					</S.AreaPrice>
					<CountControl
						removeArrow={isPaintProject}
						isBlocked={(integration && isQuoteOpen) || (integration && isQuoteManual)}
						initialCount={quantity}
						maxCount={stock}
						customMargin=""
						onDecrement={(count) => onClickDecrement(guidSupplier, guidQuoteSupplierItem, idPartType, count)}
						onIncrement={(count) => onClickIncrement(guidSupplier, guidQuoteSupplierItem, idPartType, count)}
					/>
				</S.CustomRowFlex>
			</S.AreaInfo>
		</S.Container>
	);
}

export default InfoProduct;
